module.exports = __webpack_public_path__ + "static/media/logo-gl.3b86bea3.png";